<script>
import Datepicker from 'vuejs-datepicker'
import {ptBR} from 'vuejs-datepicker/dist/locale'

export default {
  props: {
    value: {
      type: String
    },
    horas: {
      type: Boolean,
      default: false
    },
    tipo: {
      type: String,
      default: 'datetime',
      required: false
    },
    retroativo: {
      type: Boolean,
      default: true
    },
    titleBotao: {
      type: String,
      default: 'Clique para selecionar uma data'
    },
    classe: {
      type: String,
      default: 'date',
      required: false
    },
    validaBissexto: {
      type: Boolean,
      default: true
    }
  },
  components: {
    Datepicker
  },
  data: () => ({
    fieldValue: '',
    config: {
      ptBR: ptBR,
      maxlength: 10
    },
    model: ''
  }),
  methods: {
    dataInicial (date) {
      let currentDate = new Date(0)
      if (!this.retroativo) {
        currentDate = new Date()
      }
      currentDate.setDate(currentDate.getDate() - 1)
      return date < currentDate
    },
    showCalendar () {
      this.$refs.calendar.showCalendar()
    },
    trataEmiteValor () {
      if (this.fieldValue.length === 10) {
        let dataEmit = this.fieldValue.split('/')
        if (dataEmit[2]) {
          if (this.validaData(this.fieldValue)) {
            this.model = dataEmit[2] + '-' + dataEmit[1] + '-' + dataEmit[0] + 'T04:00:00.000Z'
            this.$emit('change', dataEmit[2] + '-' + dataEmit[1] + '-' + dataEmit[0] + 'T00:00:00.000Z')
          } else {
            this.$emit('change', '')
            setTimeout(() => { this.fieldValue = '' }, 1000)
          }
        }
      } else this.$emit('change', '')
    },
    validaData: function (valor) {
      var date = valor
      var ardt = []
      var ExpReg = new RegExp('(0[1-9]|[12][0-9]|3[01])/(0[1-9]|1[012])/[12][0-9]{3}')
      ardt = date.split('/')
      for (let x = 0; x < ardt.length; x++) {
        ardt[x] = parseInt(ardt[x])
      }
      var erro = false
      if (date.search(ExpReg) === -1) {
        this.warnMSG('Data inválida')
        erro = true
      } else if (((ardt[1] === 4) || (ardt[1] === 6) || (ardt[1] === 9) || (ardt[1] === 11)) && (ardt[0] > 30)) {
        this.warnMSG('Data inválida')
        erro = true
      } else if (ardt[1] === 2 && this.validaBissexto) {
        if ((ardt[0] > 28) && ((ardt[2] % 4) !== 0)) {
          this.warnMSG('Data inválida (ano digitado não é bissexto)')
          erro = true
        } if ((ardt[0] > 29) && ((ardt[2] % 4) === 0)) {
          this.warnMSG('Data inválida')
          erro = true
        }
      } else if (ardt[1] === 2 && (ardt[0] > 29)) {
        this.warnMSG('Data inválida')
        erro = true
      }
      if (erro) return false
      return true
    }
  },
  mounted () {
    if (this.value && this.value !== '') {
      let dataQuebrada = this.value.split('T')
      dataQuebrada = dataQuebrada[0].split('-')
      this.fieldValue = dataQuebrada[2] + '-' + dataQuebrada[1] + '-' + dataQuebrada[0]
      if (!this.model) this.model = this.value
    }
  },
  watch: {
    classe: function (value) {
      if (value === 'date') this.config.maxlength = 10
    },
    fieldValue: function (newValue, oldValue) {
      if (newValue && newValue.length > 0) {
        newValue = newValue.replace(/\//g, '-').replace('T00:00:00.000Z', '')
        if (newValue !== oldValue) {
          this.trataEmiteValor()
        }
      } else this.trataEmiteValor()
    },
    value: function (value, oldValue) {
      if (value && value.length > 0) {
        let dataQuebrada = this.value.split('T')
        dataQuebrada = dataQuebrada[0].split('-')
        if (dataQuebrada[2]) this.fieldValue = dataQuebrada[2] + '-' + dataQuebrada[1] + '-' + dataQuebrada[0]
        else this.fieldValue = this.value.replace(/\//g, '-')

        if (value && this.model) {
          let v = value.split('T')
          let m = this.model.split('T')
          if (v[0] && m[0]) {
            if (v[0] !== m[0]) this.model = value
          }
        } else if (value) this.model = value
      } else {
        if (oldValue) this.fieldValue = ''
        this.trataEmiteValor()
      }
    },
    model: function (value, oldValue) {
      if (this.$moment(value).format('DD-MM-YYYY') !== this.fieldValue) {
        this.fieldValue = this.$moment(value).format('DD/MM/YYYY')
        this.trataEmiteValor()
      }
    }
  }
}
</script>

<template>
<div class="mydatepiker" :class="classe">
  <input type="text" v-model="fieldValue" v-mask="'##/##/####'" class="digitar" :maxlength="config.maxlength" />
  <b-button type="button" @click="showCalendar" class='fa fa-calendar btn btn-primary' :title="titleBotao" ></b-button>
  <br />
  <datepicker
    ref="calendar"
    :language="config.ptBR"
    v-model="model"
    :type='tipo'>
  </datepicker>
</div>
</template>

<style>
.mydatepiker {
  width: 170px;
}
.mydatepiker.date {
  width: 130px;
}
.mydatepiker .digitar {
  width: 130px;
  border-top-right-radius: 0px;
  border-bottom-right-radius: 0px;
  border-right: none;
  float: left;
}
.mydatepiker.date .digitar {
  width: 100px;
}
.mydatepiker .btn {
  border-top-left-radius: 0px;
  border-bottom-left-radius: 0px;
  background: #a5a5a5;
  border: #8e8e8e solid 1px;
  border-left: none;
  padding: 0.5rem 5px;
  float:left;
  font-size: 14px;
}
.mydatepiker .vdp-datepicker input[type='text'] {
  height: 0!important;
  width: 0!important;
  padding: 0!important;
  border: none!important
}
.mydatepiker br {
  clear:both;
}
.dateSmall .btn, .dateSmall input{
  height: 20px;
  line-height: 20px;
  font-size: 12px;
}
.dateSmall input {
  width: 85px!important;
}
.dateSmall .btn {
  padding-top: 0px;
}
</style>



// WEBPACK FOOTER //
// date-picker-calendar.vue?5244ee44